import HelloARLegacyTracker from "./HelloARLegacyTracker";
import { generateUUID } from "../shared/UUIDGenerator";
import { debounce } from "../shared/useDebounce";
class ProductSessionTracker {
    constructor({ server, parentSessionId }) {
        this.callbacks = {};
        this.getSessionId = () => {
            return this.sessionId;
        };
        this.reset = () => {
            this.legacyTracker.reset();
            this.sessionId = generateUUID();
        };
        this.setEventCallback = (eventName, callback) => {
            this.callbacks[eventName] = callback;
        };
        this.requested = (productId, applicationId) => {
            this.legacyTracker.reset();
            this.legacyTracker.setSessionId(this.sessionId);
            this.legacyTracker.requested(productId, applicationId);
        };
        this.loaded = () => {
            this.legacyTracker.loaded();
        };
        this.viewed = () => {
            this.legacyTracker.viewed();
        };
        this.interactedInternal = () => {
            if (this.callbacks["ON_PRODUCT_INTERACTED"]) {
                const fn = this.callbacks["ON_PRODUCT_INTERACTED"];
                fn();
            }
            this.legacyTracker.interacted();
        };
        this.interacted = debounce(this.interactedInternal, 700);
        this.arStarted = () => {
            this.legacyTracker.arStarted();
        };
        this.arStopped = () => {
            this.legacyTracker.arStopped();
        };
        this.sessionId = generateUUID();
        this.parentSessionId = parentSessionId;
        this.legacyTracker = new HelloARLegacyTracker({ server });
        this.legacyTracker.setSessionId(this.sessionId);
        if (this.parentSessionId) {
            this.legacyTracker.setParentSessionId(this.parentSessionId);
        }
        if (server === "PROD") {
            this.legacyTracker.useProdServer();
        }
        else {
            this.legacyTracker.useDevServer();
        }
    }
}
export default ProductSessionTracker;
